import React from 'react';
import styled from 'styled-components';

function EmbeddedPage({ url }) {
  const target = url || 'about:blank';

  return (
    <Container>
      <iframe
        className="embedded-page__frame"
        src={target}
        title="embedded-page"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <button
        className="embedded-page__fallback"
        type="button"
        onClick={() => window.open(target, '_blank', 'noopener,noreferrer')}
      >
        在新标签打开
      </button>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  inset: 0;
  background: #fff;
  .embedded-page__frame {
    width: 100%;
    height: 100%;
    border: 0;
  }
  .embedded-page__fallback {
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 11px;
    border: 1px solid #6a87c8;
    border-radius: 3px;
    padding: 4px 8px;
    background: linear-gradient(180deg, #f7fbff 0%, #e7efff 100%);
    cursor: pointer;
  }
`;

export default EmbeddedPage;
